import React, {useCallback, useMemo} from "react";
import {StartActionType} from "../index";
import {ListAltOutlined} from "@mui/icons-material";
import {setReduxDialogState} from "../../../../redux/slices/dialogs/actions";
import ReduxStoreRoutes from "../../../../../core/models/static/routes/redux-store-routes";
import {useDispatch} from "react-redux";
import {Breakpoint} from "@mui/material";
import useAccessLevels from "../../../../hooks/use-access-levels";
import {useTranslation} from "react-i18next";

const useQuickOrderStartAction = (breakpoint: Breakpoint | number): StartActionType | null => {
    const dispatch = useDispatch();
    const operatorAccessLevels = useAccessLevels();
    const {t} = useTranslation("components", {keyPrefix: 'panel-sections.app-bar.actions.start-action-buttons'});

    /**
     * Opens quick order dialog
     */
    const openQuickOrderDialog = useCallback(() => {
        dispatch(setReduxDialogState(ReduxStoreRoutes.dialogs.quickOrders, {open: true}));
    }, [dispatch])

    return useMemo<StartActionType | null>(() =>
            !operatorAccessLevels.packages.sales.quickOrder
                ? null
                : ({
                    key: 'quick-order',
                    title: t(t => t['quick-order']),
                    color: "primary" as any,
                    icon: <ListAltOutlined/>,
                    onClick: openQuickOrderDialog,
                    breakpoint: breakpoint,
                    buttonBreakpoint: 'xl',
                    variant: 'outlined',
                }),
        [operatorAccessLevels.packages.sales.quickOrder, t, openQuickOrderDialog, breakpoint])
}

export default useQuickOrderStartAction;
